import {
  Stack, Box, Typography, FormGroup, FormControlLabel, Checkbox,
} from '@mui/material';
import { CloseIcon } from 'assets/icons';
import { sortByFilters, typeFilters } from 'pages/media-library/constants';
import { selectFiltersApplied, selectSortBy, selectType } from 'pages/media-library/selector';
import { mediaLibraryAction } from 'pages/media-library/slice';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

const MyMediaFilters = () => {
  const dispatch = useDispatch();

  const sortBy = useSelector(selectSortBy);
  const type = useSelector(selectType);
  const filtersApplied = useSelector(selectFiltersApplied);

  return (
    <Stack spacing={{ xs: 3, md: 4 }}>
      <Box>
        <Typography variant="body1" mb={{ xs: 1, md: 1 }}>
          Sort by
        </Typography>
        {sortByFilters.map((item) => (
          <FormGroup key={item.text}>
            <FormControlLabel
              control={<Checkbox checked={sortBy === item.value} />}
              label={
                <Typography variant="body1" sx={{ color: 'text.secondary' }}>{item.text}</Typography>
              }
              value={item.value}
              onChange={() => {
                if (sortBy === item.value) {
                  return;
                }

                dispatch(mediaLibraryAction.setSortBy(item.value));
              }}
            />
          </FormGroup>
        ))}
      </Box>

      <Box>
        <Typography variant="body1" mb={{ xs: 1, md: 1 }}>
          Type
        </Typography>
        {typeFilters.map((item, index) => (
          <FormGroup key={item.text}>
            <FormControlLabel
              control={<Checkbox checked={type.includes(item.value)} />}
              label={
                <Typography variant="body1" sx={{ color: 'text.secondary' }}>{item.text}</Typography>
              }
              value={item.value}
              onChange={() => {
                dispatch(mediaLibraryAction.setType(item.value));
              }}
            />
          </FormGroup>
        ))}
      </Box>

      {filtersApplied && (
        <Box
          display="flex"
          alignItems="center"
          gap={2}
          sx={{ cursor: 'pointer' }}
          onClick={() => dispatch(mediaLibraryAction.clearFilters())}
        >
          <CloseIcon sx={{ fontSize: { xs: 18, md: 20 } }} />
          <Typography
            fontWeight="bold"
            color="primary"
            fontSize={{ xs: 14, md: 16 }}
          >
            Clear filters
          </Typography>
        </Box>
      )}
    </Stack>
  );
};

export default MyMediaFilters;
